import format from "date-fns/format";

const DATE_FORMAT = "DD.MM.YYYY";
const DATE_FORMAT_TIME = "DD.MM.YYYY HH:mm";

export const formatDate = (date) => {
  return format(new Date(date), DATE_FORMAT);
};

export const formatDateTime = (date) => {
  return format(new Date(date), DATE_FORMAT_TIME);
};



// WEBPACK FOOTER //
// ./src/lib/formats.js